import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { isIgnorableClientError } from './ignorableClientErrors';

if (process.env.NEXT_PUBLIC_BUGSNAG_KEY) {
  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY,
    plugins: [new BugsnagPluginReact()],
    onError: (event) =>
      !event.errors.some((error) =>
        isIgnorableClientError(error.errorMessage || '')
      ),
  });
}

export default Bugsnag;
